export abstract class MockInterceptor {
  protected areMocksEnabled() {
    return false;
  }
}
